export const colors = {
  white: "#fff",
  grayLight: "#f5f5f5",
  gray: "#eaeaea",
  gray2: "#E8E8E8",
  gray3: "#888",
  black: "#2B2B2B",
  dark: "#292D41",
  darkRgba15: "rgba(41,45,65, 0.15)",
  darkRgba25: "rgba(41,45,65, 0.25)",
  darkRgba8: "rgba(41,45,65, 0.08)",
  darkRgba5: "rgba(41,45,65, 0.05)",
  blueLight: "#3498DB",
  blueDark: "#43475C",
  lightDarkBlue: "#616788",
  lightBlueGray: "#C8CFD4",
  green: "#27ae60",
  line: "#D8DAE8",
  blue: "#1976D2",
  red: "#ec1751",
  orange: "#FF8509",
  darkOrange: "#F7630C",
  yellow: "#FFFABF",
  beige: "#CBB25E",
  purple: "#774CA2",
  purple2: "#5D4CA2",
  purple3: "#614BBA",
};

export const colorScheme = {
  primary: colors.orange,
  secondary: colors.blueDark,
  warning: colors.orange,
  text: colors.dark,
};
